export default {
  body: {
    id: 'product_jp_product_condition_switcher_body',
    defaultMessage: 'Body',
  },
  screen: {
    id: 'product_jp_product_condition_switcher_screen',
    defaultMessage: 'Screen',
  },
}
